import React, { Component } from 'react';
import './password.css';
import { AppCollapsible } from '../AppCollapsible';
import { connect } from 'react-redux';
import { editInputWithProps } from '../../../redux/actions/inputWithProps';
import { AppInputWrapper } from '../AppInputWrapper';


class Password extends Component {

    state = {
        showDefaultPassword: false,
        showPassword: false,
        showRepeatPassword: false,

        mainLabel: this.props.initialValues.mainLabel || 'Password',
        repeatLabel: this.props.initialValues.repeatLabel || 'Repeat password',
        useDefaultPass: this.props.initialValues.useDefaultPass || false,
        defaultPassValue: this.props.initialValues.value || '',
        mainPassValue: '',
        repeatPassValue: '',

        repeatPassNotMatchError: false,
        requiredError: !this.props.initialValues.useDefaultPass,
    };

    updateInputPropsInStore = () => {
        const inputProps = {
            type: this.props.initialValues.type,
            useDefaultPass: this.state.useDefaultPass
        };

        if (this.state.useDefaultPass) {
            inputProps['value'] = this.state.defaultPassValue;
            inputProps['_value'] = this.state.defaultPassValue;
        } else {
            inputProps['mainLabel'] = this.state.mainLabel;
            inputProps['repeatLabel'] = this.state.repeatLabel;
            inputProps['_value'] = this.state.mainPassValue;
            inputProps['_hasValidationErrors'] = this.state.repeatPassNotMatchError || this.state.requiredError;
        }

        this.props.editInputWithProps(this.props.initialValues.id, inputProps);
    };

    componentDidMount() {
        setTimeout(_ => {
            this.updateInputPropsInStore();
        }, 500);
    }

    componentDidUpdate() {
        this.updateInputPropsInStore();
    }

    setLabel = (e, target) => {
        this.setState({ [target]: e.target.value })
    };

    setDefaultPassOption = (e) => {
        this.setState({ useDefaultPass: e.target.checked });
    };

    handlePassChange = (name, value) => {

        const newState = { [name]: value };

        const { repeatPassValue, mainPassValue } = this.state;
        if (name === 'mainPassValue') {
            newState['repeatPassNotMatchError'] = (repeatPassValue && value) ? repeatPassValue !== value : false
            newState['requiredError'] = !repeatPassValue || !value;
        }

        if (name === 'repeatPassValue') {
            newState['repeatPassNotMatchError'] = (mainPassValue && value) ? mainPassValue !== value : false;
            newState['requiredError'] = !mainPassValue || !value;
        }

        this.setState(newState);
    }

    togglePasswordVisibility = (name) => {
        this.setState({ [name]: !this.state[name] });
    };

    renderPassInput = (name, visibilityName) => (
        <div
            className="default-input-wrapper"
            data-validation-error={name === 'repeatPassValue' && this.state.repeatPassNotMatchError}
        >
            <input
                value={this.state[name]}
                onChange={(e) => this.handlePassChange(name, e.target.value)}
                className="default-pass-input"
                type={this.state[visibilityName] ? 'text' : 'password'}
                placeholder="Type..."
                autoComplete="new-password"
            />
            <i
                onClick={() => this.togglePasswordVisibility(visibilityName)}
                className={`fa ${!this.state[visibilityName] ? 'fa-eye-slash' : 'fa-eye'} pass-eye-icon`}
                aria-hidden="true"
            />
        </div>
    );

    render() {
        const { textColor, isResultInput } = this.props;
        const { useDefaultPass, mainLabel, repeatLabel, repeatPassNotMatchError, requiredError } = this.state;
        return (
            <>
                {
                    !useDefaultPass ?
                        <>
                            <AppInputWrapper
                                label={mainLabel}
                                color={textColor}
                                required={true}
                                requiredError={requiredError}
                            >
                                { this.renderPassInput('mainPassValue', 'showPassword') }
                            </AppInputWrapper>

                            <AppInputWrapper
                                customClass={'repeat-pass_block'}
                                label={repeatLabel}
                                color={textColor}
                            >
                                <>
                                    { this.renderPassInput('repeatPassValue', 'showRepeatPassword') }
                                    {
                                        repeatPassNotMatchError &&
                                        <span className="validation-error-text">Passwords do not match</span>
                                    }
                                </>
                            </AppInputWrapper>
                        </>
                    :
                    <AppInputWrapper
                        customClass={'default-pass_block'}
                        label={'Default password'}
                        color={textColor}
                        required={false}
                    >
                        { this.renderPassInput('defaultPassValue', 'showDefaultPassword') }
                    </AppInputWrapper>
                }
                {
                    !isResultInput &&
                    <AppCollapsible>
                        <div className="settings-container">

                            <label>
                                <input
                                    checked={useDefaultPass}
                                    className="password-checkbox_value"
                                    type="checkbox"
                                    onChange={this.setDefaultPassOption}
                                />
                                <span className="password-checkbox_option">Use default password</span>
                            </label>

                            {
                                !useDefaultPass ?
                                    <>
                                        <label>
                                            <input
                                                onChange={(e) => this.setLabel(e, 'mainLabel')}
                                                value={mainLabel}
                                                type="text"
                                            />
                                            Main label
                                        </label>

                                        <label>
                                            <input
                                                onChange={(e) => this.setLabel(e, 'repeatLabel')}
                                                value={repeatLabel}
                                                type="text"
                                            />
                                            Repeat label
                                        </label>
                                    </> : null
                            }
                        </div>
                    </AppCollapsible>
                }
            </>
        )
    }
}

export default connect(
    () => ({}),
    {
        editInputWithProps
    }
)(Password)